import React, { useState } from 'react';
import Sidebar from '../settingsPage/sidebar';
import SettingsPanel from '../settingsPage/settingsPanel';
import './settingsPage.css';

function SettingsPage() {
  const [selectedSetting, setSelectedSetting] = useState('System Preferences');

  return (
    <div className="app-container">
      <Sidebar selected={selectedSetting} onSelect={setSelectedSetting} />
      <SettingsPanel setting={selectedSetting} />
    </div>
  );
}

export default SettingsPage;
